import React from "react";
import styles from "../PlanCard.module.css";
import { List } from "@shopify/polaris";
import { SUBSCRIPTION_PLAN_ENTERPRISE } from "../../../../../../../../constants/subscriptionPlans.js";

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const ListSection = ({ plan }) => {
  return (
    <div className={styles.listWrapper}>
      <List type="bullet">
        <List.Item>
          {
            plan.name === SUBSCRIPTION_PLAN_ENTERPRISE ?
              <p>More than 10,000 Products</p> :
              <p>Up to {numberWithCommas(plan.productsLimit)} Products</p>
          }
        </List.Item>
        <List.Item>
          {
            plan.name === SUBSCRIPTION_PLAN_ENTERPRISE ?
              <p>More than 500 Collections</p> :
              <p>Up to {numberWithCommas(plan.collectionsLimit)} Collections</p>
          }
        </List.Item>
        <List.Item>
          Push down / hide out-of-stock items
        </List.Item>
        <List.Item>
          Tag Products
        </List.Item>
        <List.Item>
          Redirect
        </List.Item>
        <List.Item>
          Advanced Rules
        </List.Item>
        <List.Item>
          Stock Alerts & Reports
        </List.Item>
        <List.Item>
          And more!
        </List.Item>
      </List>
    </div>
  );
};

export default ListSection;